"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
const useStationStops = _ref => {
  let {
    selectedTown,
    stationStops
  } = _ref;
  const [stationStopsByTown, setStationStopsByTown] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    if (!selectedTown) return;
    const filteredStops = stationStops === null || stationStops === void 0 ? void 0 : stationStops.filter(station => station.city === selectedTown);
    setStationStopsByTown(filteredStops);
  }, [selectedTown, stationStops]);
  return stationStopsByTown;
};
var _default = exports.default = useStationStops;